import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import {FusePageSimple} from '@fuse';

const styles = theme => ({
    layoutRoot: {}
});

class UnauthorizedPage extends Component {

    constructor(props){
        super(props);
        this.state = {
            errorMessage : null
        };  
    }

    render()
    {
        const {classes} = this.props;
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Unauthorized Page</h4></div>
                }
                contentToolbar={
                    <div className="px-24"><h4></h4></div>
                }
                content={
                    <div className="p-24">
                        <h4>Error</h4>
                        <br/>
                        You do not have permission to access this page
                    </div>
                }
            />
        )
    }
}

export default withStyles(styles, {withTheme: true})(UnauthorizedPage);


// WEBPACK FOOTER //
// ./src/main/content/unauthorizedPage/UnauthorizedPage.js